import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { CloseIcon } from '../icons';

const StyledChip = styled(Chip)(() => ({
  fontWeight: 500,
  borderRadius: 6,
  height: 24,
  '& .MuiChip-label': {
    padding: '2px 8px',
  },
  '& .MuiChip-deleteIcon': {
    marginRight: 6,
  },
}));

const Tag = ({ label, ...props }) => {
  return (
    <StyledChip
      deleteIcon={props.onDelete && <CloseIcon />}
      {...props}
      label={label}
    />
  );
};

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['filled', 'outlined', 'text']),
  color: PropTypes.string,
};

export default Tag;